import React from 'react';

import './index.css';

export default ({ image, title, description, openVacancyModal, word }) => (
  <div className="vacancy" onClick={openVacancyModal}>
    <div className="vacancy__image">
      <div className="vacancy__job">
        <span>{word}</span>
      </div>
      <img src={image} alt="" />
    </div>
    <h3 className="vacancy__title">{localStorage.getItem('lang') == 'ru'? title[0]:title[1]}</h3>
    <p className="vacancy__description">{localStorage.getItem('lang') == 'ru'? description[0]:description[1]}</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/vacancyPreview/index.jsx